import React from "react";
import ButtonHoverEffect from "./ButtonHoverEffect";
import LazyLoadingImg from "./LazyLoadingImg";
import { useNavigate } from "react-router-dom";
import useWindowWidth from "../../hooks/useWindowWidth";
import ExploreButton from "./ExploreButton/Index";
export default function NewHomePortfolioComponent(props) {
  const navigate = useNavigate();
  const width = useWindowWidth();
  return (
    <>
      <div className={`${props.mainClass}`}>
        <div
          className={`row ${props.ImagePosition} ${
            props.more ? props.more : ""
          } mx-0`}
        >
          <div
            className="col-md-5 px-0 text-center pfbrdrtop align-content-center"
            style={{
              backgroundColor: `${props.PortfolioCardBGC}`,
              borderRadius:
                width < 768
                  ? "20px 20px 0px 0px"
                  : props.ImagePosition?.includes("image-pos-right")
                  ? "0px 20px 20px 0px"
                  : "20px 0px 0px 20px",
            }}
          >
            <LazyLoadingImg
              src={`/images/${props.imgSrc}`}
              className={` ${props.customMarginImg} ${
                props.imgHeight ? "h-100" : ""
              } `}
            />
          </div>
          <div
            className={`col-md-7 content-container pfbrdrbtm ${props.cardClass}`}
            style={{
              borderRadius:
                width < 768
                  ? " 0px 0px 20px 20px"
                  : props.ImagePosition?.includes("image-pos-right")
                  ? "20px 0px 0px 20px"
                  : "0px 20px 20px 0px",
            }}
          >
            <h2 className={props.titleClass}>{props.title}</h2>
            <div className="row pt-2 pb-3">
              <div className={props.customSectionCol}>
                <div className="row">
                  <div
                    className={props.customSection1Col}
                    style={{
                      borderRight: `1px solid ${props.borderColor} `,
                      // lineHeight: props.customLineHeight,
                    }}
                  >
                    <div className={`pfFont-1`}>{props.sectionOneTextOne}</div>
                    <div className={`${props.sectionTextColor}`}>
                      {props.sectionOneTextTwo}
                    </div>
                  </div>
                  <div
                    className={props.customSection2Col}
                    style={{
                      paddingLeft: `${props.customSection2ColPadding}`,
                      // lineHeight: props.customLineHeight,
                    }}
                  >
                    <div className={`pfFont-1`}>{props.sectionTwoTextOne}</div>
                    <div className={`${props.sectionTextColor}`}>
                      {props.sectionTwoTextTwo}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="new-portfolio-technology"> Technologies Used</div>
            {props.linkTitle.split(",").map((item, index) => (
              <span key={index + item}>
                {" "}
                <img
                  src={`/images/Technology/${item.trim()}`}
                  alt={item}
                  className={`me-3 img-fluid mt-3 portfolio-images${
                    props.techImgClass ? ` ${props.techImgClass}` : ""
                  }`}
                />
              </span>
            ))}
            {props.portfolioBtn && (
              <div className="d-flex  pt-3">
                <ButtonHoverEffect RedirectUrl={props.redirectNumber} />
              </div>
            )}
            {/* {props.portfolioBtn && (
              <div
                className="d-flex  pt-4"
                onClick={() => {
                  if (
                    props.redirectNumber != undefined &&
                    props.redirectNumber != null &&
                    props.redirectNumber != ""
                  ) {
                    if (props.IsRedirectToSamePage == "yes") {
                      navigate(props.redirectNumber);
                    } else {
                      window.open(`${props.redirectNumber}`, "_blank");
                    }
                  }
                }}
              >
                <ExploreButton color={props.portfolioBtnColor} />
              </div>
            )} */}
          </div>
        </div>
      </div>
    </>
  );
}
